import {
  ChangeDetectorRef,
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
} from '@angular/core';
import { HighchartsThemeService, ResponsiveService } from '@frk/eds-components';
import { SiteConfigService } from '@services';
import { setHighChartLangOptions } from '@utils/il8n/moment-il8n';
import { Observable } from 'rxjs';

@Component({
  selector: 'ft-fund-performance-monthly-total-returns-chart',
  templateUrl: './fund-performance-monthly-total-returns-chart.component.html',
  styleUrls: ['./fund-performance-monthly-total-returns-chart.component.scss'],
})
export class FundPerformanceMonthlyTotalReturnsChartComponent
  implements OnInit, OnChanges {
  @Input() highChartOptions: Highcharts.Options;
  public highcharts;
  public chartOptions: Highcharts.Options = {};

  public isMobile$: Observable<boolean>;

  constructor(
    private highchartsTheme: HighchartsThemeService,
    private siteConfig: SiteConfigService,
    private responsiveService: ResponsiveService,
    private changeDetectorRef: ChangeDetectorRef
  ) {
    this.isMobile$ = this.responsiveService.isMobile$();
  }

  ngOnInit(): void {
    import(/* webpackChunkName: "highcharts-async" */ 'highcharts').then(
      (highchartsModule) => {
        highchartsModule.setOptions({
          lang: setHighChartLangOptions(this.siteConfig.getPdsLanguage()),
        });
        highchartsModule.setOptions(this.highchartsTheme.themeOptions);
        require('highcharts/modules/accessibility')(highchartsModule);
        this.highcharts = highchartsModule;
      }
    );
    this.chartOptions = this.highChartOptions;
    this.changeDetectorRef.detectChanges();
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (!changes.highChartOptions.firstChange) {
      this.chartOptions = changes.highChartOptions.currentValue;
    }
  }
}
